export type TCommandName = "REFRESH" | "SNAPSHOT";

type THandler = () => Promise<void>;

const handlers = new Map<TCommandName, THandler>();

export function registerCommand(name: TCommandName, handler: THandler): void {
  handlers.set(name, handler);
}

export function clearCommands(): void {
  handlers.clear();
}

/**
 * The ribbon and the task pane share one runtime, so a ribbon press runs the pane's own handler and
 * goes through the same validation. A press before the pane has registered is a no-op rather than a
 * second, unvalidated path into the workbook.
 */
export function associateCommands(): void {
  if (typeof Office === "undefined" || !Office.actions?.associate) {
    return;
  }

  (["REFRESH", "SNAPSHOT"] as TCommandName[]).forEach((name) =>
    Office.actions.associate(name, (event: Office.AddinCommands.Event) => {
      const handler = handlers.get(name);

      if (!handler) {
        event.completed();

        return;
      }

      handler().finally(() => event.completed());
    }),
  );
}
